﻿'use strict';

/**
 * @ngdoc service
 * @name ntmApp.Comparers
 * @description
 * # Comparers
 * Service in the ntmApp.
 */

angular.module('ntmApp')
  .factory('Comparers', function () {

      var comparers = {};


      comparers.ScenarioComparer = function (name1, name2) {

          var currentForecastTitle = 'Current Forecast';

          if (name1.toUpperCase() === currentForecastTitle.toUpperCase()) {
              return -1;
          }

          if (name2.toUpperCase() === currentForecastTitle.toUpperCase()) {
              return 1;
          }

          return compareScenarioNames(name1, name2);
      };

      function compareScenarioNames(name1, name2) {
          var scenarioNumber1 = parseInt(name1.substring("Scenario".length, name1.length).trim());
          var scenarioNumber2 = parseInt(name2.substring("Scenario".length, name2.length).trim());
          return scenarioNumber1 - scenarioNumber2;
      }

      return comparers;

  });